// IDIOMAS DEL ESTANDAR ISO 639-1
const LANG = {
  // Idiomas mas relevantes
  ENGLISH: { key: "en", value: "en", name_en: "English", name: "English" },
  SPANISH_MX: { key: "es-MX", value: "es-MX", name_en: "Spanish (Mexico)", name: "Español (México)" },
  SPANISH_ES: { key: "es", value: "es", name_en: "Spanish (Spain)", name: "Español (España)" },
  CHINESE_SIMP: {
    key: "zh-Hans",
    value: "zh-Hans",
    name_en: "Chinese (Simplified)",
    name: "中文 (简体)",
  },
  CHINESE_TRAD: {
    key: "zh-Hant",
    value: "zh-Hant",
    name_en: "Chinese (Traditional)",
    name: "中文 (繁體)",
  },
  PORTUGUESE_BR: {
    key: "pt-BR",
    value: "pt-BR",
    name_en: "Portuguese (Brazil)",
    name: "Português (Brasil)",
  },
  PORTUGUESE_PT: {
    key: "pt-PT",
    value: "pt-PT",
    name_en: "Portuguese (Portugal)",
    name: "Português (Portugal)",
  },
  GERMAN: { key: "de", value: "de", name_en: "German", name: "Deutsch" },
  FRENCH: { key: "fr", value: "fr", name_en: "French", name: "Français" },
  RUSSIAN: { key: "ru", value: "ru", name_en: "Russian", name: "Русский" },
  JAPANESE: { key: "ja", value: "ja", name_en: "Japanese", name: "日本語" },
  ARABIC: { key: "ar", value: "ar", name_en: "Arabic", name: "العربية" },
  HINDI: { key: "hi", value: "hi", name_en: "Hindi", name: "हिन्दी" },
  ITALIAN: { key: "it", value: "it", name_en: "Italian", name: "Italiano" },
  KOREAN: { key: "ko", value: "ko", name_en: "Korean", name: "한국어" },
  TURKISH: { key: "tr", value: "tr", name_en: "Turkish", name: "Türkçe" },
  DUTCH: { key: "nl", value: "nl", name_en: "Dutch", name: "Nederlands" },
  POLISH: { key: "pl", value: "pl", name_en: "Polish", name: "Polski" },
  CATALAN: { key: "ca", value: "ca", name_en: "Catalan", name: "Català" },
  SWEDISH: { key: "sv", value: "sv", name_en: "Swedish", name: "Svenska" },
  UKRAINIAN: { key: "uk", value: "uk", name_en: "Ukrainian", name: "Українська" },

  VIETNAMESE: { key: "vi", value: "vi", name_en: "Vietnamese", name: "Tiếng Việt" },
  INDONESIAN: { key: "id", value: "id", name_en: "Indonesian", name: "Bahasa Indonesia" },
  THAI: { key: "th", value: "th", name_en: "Thai", name: "ไทย" },

  // Resto de idiomas
  ABKHAZIAN: { key: "ab", value: "ab", name_en: "Abkhazian", name: "аԥсшәа" },
  AFAR: { key: "aa", value: "aa", name_en: "Afar", name: "Afaraf" },
  AFRIKAANS: { key: "af", value: "af", name_en: "Afrikaans", name: "Afrikaans" },
  AKAN: { key: "ak", value: "ak", name_en: "Akan", name: "Akan" },
  ALBANIAN: { key: "sq", value: "sq", name_en: "Albanian", name: "Shqip" },
  AMHARIC: { key: "am", value: "am", name_en: "Amharic", name: "አማርኛ" },
  ARAGONESE: { key: "an", value: "an", name_en: "Aragonese", name: "Aragonés" },
  ARMENIAN: { key: "hy", value: "hy", name_en: "Armenian", name: "Հայերեն" },
  ASSAMESE: { key: "as", value: "as", name_en: "Assamese", name: "অসমীয়া" },
  AVARIC: { key: "av", value: "av", name_en: "Avaric", name: "авар мацӀ" },
  AVESTAN: { key: "ae", value: "ae", name_en: "Avestan", name: "avesta" },
  AYMARA: { key: "ay", value: "ay", name_en: "Aymara", name: "Aymar aru" },
  AZERBAIJANI: { key: "az", value: "az", name_en: "Azerbaijani", name: "azərbaycan dili" },
  BAMBARA: { key: "bm", value: "bm", name_en: "Bambara", name: "bamanankan" },
  BASHKIR: { key: "ba", value: "ba", name_en: "Bashkir", name: "башҡорт теле" },
  BASQUE: { key: "eu", value: "eu", name_en: "Basque", name: "Euskara" },
  BELARUSIAN: { key: "be", value: "be", name_en: "Belarusian", name: "беларуская мова" },
  BENGALI: { key: "bn", value: "bn", name_en: "Bengali", name: "বাংলা" },
  BISLAMA: { key: "bi", value: "bi", name_en: "Bislama", name: "Bislama" },
  BOSNIAN: { key: "bs", value: "bs", name_en: "Bosnian", name: "bosanski jezik" },
  BRETON: { key: "br", value: "br", name_en: "Breton", name: "brezhoneg" },
  BULGARIAN: { key: "bg", value: "bg", name_en: "Bulgarian", name: "български език" },
  BURMESE: { key: "my", value: "my", name_en: "Burmese", name: "ဗမာစာ" },
  CENTRAL_KHMER: { key: "km", value: "km", name_en: "Central Khmer", name: "ខ្មែរ" },
  CHAMORRO: { key: "ch", value: "ch", name_en: "Chamorro", name: "Chamoru" },
  CHECHEN: { key: "ce", value: "ce", name_en: "Chechen", name: "нохчийн мотт" },
  CHICHEWA: { key: "ny", value: "ny", name_en: "Chichewa", name: "chiCheŵa" },
  CHURCH_SLAVIC: {
    key: "cu",
    value: "cu",
    name_en: "Church Slavic",
    name: "ѩзыкъ словѣньскъ",
  },
  CHUVASH: { key: "cv", value: "cv", name_en: "Chuvash", name: "чӑваш чӗлхи" },
  CORNISH: { key: "kw", value: "kw", name_en: "Cornish", name: "Kernewek" },
  CORSICAN: { key: "co", value: "co", name_en: "Corsican", name: "corsu" },
  CREE: { key: "cr", value: "cr", name_en: "Cree", name: "ᓀᐦᐃᔭဝᐍᐤ" },
  CROATIAN: { key: "hr", value: "hr", name_en: "Croatian", name: "Hrvatski" },
  CZECH: { key: "cs", value: "cs", name_en: "Czech", name: "Čeština" },
  DANISH: { key: "da", value: "da", name_en: "Danish", name: "Dansk" },
  DIVEHI: { key: "dv", value: "dv", name_en: "Divehi", name: "ދިވެހި" },
  DZONGKHA: { key: "dz", value: "dz", name_en: "Dzongkha", name: "རྫོང་ཁ" },
  ESPERANTO: { key: "eo", value: "eo", name_en: "Esperanto", name: "Esperanto" },
  ESTONIAN: { key: "et", value: "et", name_en: "Estonian", name: "Eesti" },
  EWE: { key: "ee", value: "ee", name_en: "Ewe", name: "Eʋegbe" },
  FAROESE: { key: "fo", value: "fo", name_en: "Faroese", name: "føroyskt" },
  FIJIAN: { key: "fj", value: "fj", name_en: "Fijian", name: "vosa Vakaviti" },
  FINNISH: { key: "fi", value: "fi", name_en: "Finnish", name: "Suomi" },
  FULAH: { key: "ff", value: "ff", name_en: "Fulah", name: "Fulfulde" },
  GAELIC: { key: "gd", value: "gd", name_en: "Gaelic", name: "Gàidhlig" },
  GALICIAN: { key: "gl", value: "gl", name_en: "Galician", name: "Galego" },
  GANDA: { key: "lg", value: "lg", name_en: "Ganda", name: "Luganda" },
  GEORGIAN: { key: "ka", value: "ka", name_en: "Georgian", name: "ქართული" },
  GREEK: { key: "el", value: "el", name_en: "Greek", name: "Ελληνικά" },
  GUARANI: { key: "gn", value: "gn", name_en: "Guarani", name: "Avañe'ẽ" },
  GUJARATI: { key: "gu", value: "gu", name_en: "Gujarati", name: "ગુજરાતી" },
  HAITIAN: { key: "ht", value: "ht", name_en: "Haitian", name: "Kreyòl ayisyen" },
  HAUSA: { key: "ha", value: "ha", name_en: "Hausa", name: "Hausa" },
  HEBREW: { key: "he", value: "he", name_en: "Hebrew", name: "עברית" },
  HERERO: { key: "hz", value: "hz", name_en: "Herero", name: "Otjiherero" },
  HIRI_MOTU: { key: "ho", value: "ho", name_en: "Hiri Motu", name: "Hiri Motu" },
  HUNGARIAN: { key: "hu", value: "hu", name_en: "Hungarian", name: "Magyar" },
  ICELANDIC: { key: "is", value: "is", name_en: "Icelandic", name: "Íslenska" },
  IDO: { key: "io", value: "io", name_en: "Ido", name: "Ido" },
  IGBO: { key: "ig", value: "ig", name_en: "Igbo", name: "Asụsụ Igbo" },
  INTERLINGUA: { key: "ia", value: "ia", name_en: "Interlingua", name: "Interlingua" },
  INTERLINGUE: { key: "ie", value: "ie", name_en: "Interlingue", name: "Interlingue" },
  INUKTITUT: { key: "iu", value: "iu", name_en: "Inuktitut", name: "ᐃᓄᒃᑎᑐᑦ" },
  INUPIAQ: { key: "ik", value: "ik", name_en: "Inupiaq", name: "Iñupiaq" },
  IRISH: { key: "ga", value: "ga", name_en: "Irish", name: "Gaeilge" },
  JAVANESE: { key: "jv", value: "jv", name_en: "Javanese", name: "Basa Jawa" },
  KALAALLIT: { key: "kl", value: "kl", name_en: "Kalaallit", name: "kalaallisut" },
  KANNADA: { key: "kn", value: "kn", name_en: "Kannada", name: "ಕನ್ನಡ" },
  KANURI: { key: "kr", value: "kr", name_en: "Kanuri", name: "Kanuri" },
  KASHMIRI: { key: "ks", value: "ks", name_en: "Kashmiri", name: "कश्मीरी" },
  KAZAKH: { key: "kk", value: "kk", name_en: "Kazakh", name: "қазақ тілі" },
  KIKUYU: { key: "ki", value: "ki", name_en: "Kikuyu", name: "Gikuyu" },
  KIRGHIZ: { key: "ky", value: "ky", name_en: "Kirghiz", name: "Кыргызча" },
  KOMI: { key: "kv", value: "kv", name_en: "Komi", name: "коми кыв" },
  KONGO: { key: "kg", value: "kg", name_en: "Kongo", name: "Kikongo" },
  KUANYAMA: { key: "kj", value: "kj", name_en: "Kuanyama", name: "Kuanyama" },
  KURDISH: { key: "ku", value: "ku", name_en: "Kurdish", name: "Kurdî" },
  LAO: { key: "lo", value: "lo", name_en: "Lao", name: "ລາວ" },
  LATIN: { key: "la", value: "la", name_en: "Latin", name: "Latine" },
  LATVIAN: { key: "lv", value: "lv", name_en: "Latvian", name: "Latviešu" },
  LIMBURGAN: { key: "li", value: "li", name_en: "Limburgan", name: "Limburgs" },
  LINGALA: { key: "ln", value: "ln", name_en: "Lingala", name: "Lingála" },
  LITHUANIAN: { key: "lt", value: "lt", name_en: "Lithuanian", name: "Lietuvių" },
  LUBAKATANGA: { key: "lu", value: "lu", name_en: "Luba-Katanga", name: "Kiluba" },
  LUXEMBOURGISH: {
    key: "lb",
    value: "lb",
    name_en: "Luxembourgish",
    name: "Lëtzebuergesch",
  },
  MACEDONIAN: { key: "mk", value: "mk", name_en: "Macedonian", name: "македонски јазик" },
  MALAGASY: { key: "mg", value: "mg", name_en: "Malagasy", name: "fiteny malagasy" },
  MALAY: { key: "ms", value: "ms", name_en: "Malay", name: "Bahasa Melayu" },
  MALAYALAM: { key: "ml", value: "ml", name_en: "Malayalam", name: "മലയാളം" },
  MALTESE: { key: "mt", value: "mt", name_en: "Maltese", name: "Malti" },
  MANX: { key: "gv", value: "gv", name_en: "Manx", name: "Gaelg" },
  MAORI: { key: "mi", value: "mi", name_en: "Maori", name: "te reo Māori" },
  MARATHI: { key: "mr", value: "mr", name_en: "Marathi", name: "मराठी" },
  MARSHALLESE: { key: "mh", value: "mh", name_en: "Marshallese", name: "Kajin M̧ajeļ" },
  MONGOLIAN: { key: "mn", value: "mn", name_en: "Mongolian", name: "Монгол хэл" },
  NAURU: { key: "na", value: "na", name_en: "Nauru", name: "Dorerin Naoero" },
  NAVAJO: { key: "nv", value: "nv", name_en: "Navajo", name: "Diné bizaad" },
  NDONGA: { key: "ng", value: "ng", name_en: "Ndonga", name: "Owambo" },
  NEPALI: { key: "ne", value: "ne", name_en: "Nepali", name: "नेपाली" },
  NORTH_NDEBELE: { key: "nd", value: "nd", name_en: "North Ndebele", name: "isiNdebele" },
  NORTHERN_SAMI: {
    key: "se",
    value: "se",
    name_en: "Northern Sami",
    name: "Davvisámegiella",
  },
  NORWEGIAN: { key: "no", value: "no", name_en: "Norwegian", name: "Norsk" },
  NORWEGIAN_BOKMAL: {
    key: "nb",
    value: "nb",
    name_en: "Norwegian Bokmål",
    name: "Norsk bokmål",
  },
  NORWEGIAN_NYNORSK: {
    key: "nn",
    value: "nn",
    name_en: "Norwegian Nynorsk",
    name: "Norsk nynorsk",
  },
  OCCITAN: { key: "oc", value: "oc", name_en: "Occitan", name: "Occitan" },
  OJIBWA: { key: "oj", value: "oj", name_en: "Ojibwa", name: "ᐊᓂᔑᓈᐯᒧᐎᓐ" },
  ORIYA: { key: "or", value: "or", name_en: "Oriya", name: "ଓଡ଼ିଆ" },
  OROMO: { key: "om", value: "om", name_en: "Oromo", name: "Afaan Oromoo" },
  OSSETIAN: { key: "os", value: "os", name_en: "Ossetian", name: "ирон ӕвзаг" },
  PALI: { key: "pi", value: "pi", name_en: "Pali", name: "Pāli" },
  PANJABI: { key: "pa", value: "pa", name_en: "Panjabi", name: "ਪੰਜਾਬੀ" },
  PASHTO: { key: "ps", value: "ps", name_en: "Pashto", name: "پښتو" },
  PERSIAN: { key: "fa", value: "fa", name_en: "Persian", name: "فارسی" },
  QUECHUA: { key: "qu", value: "qu", name_en: "Quechua", name: "Runa Simi" },
  ROMANIAN: { key: "ro", value: "ro", name_en: "Romanian", name: "Română" },
  ROMANSH: { key: "rm", value: "rm", name_en: "Romansh", name: "Rumantsch" },
  RUNDI: { key: "rn", value: "rn", name_en: "Rundi", name: "Ikirundi" },
  RWANDA: { key: "rw", value: "rw", name_en: "Kinyarwanda", name: "Kinyarwanda" },
  SAMOAN: { key: "sm", value: "sm", name_en: "Samoan", name: "gagana fa'a Samoa" },
  SANGO: { key: "sg", value: "sg", name_en: "Sango", name: "yângâ tî sängö" },
  SANSKRIT: { key: "sa", value: "sa", name_en: "Sanskrit", name: "संस्कृतम्" },
  SARDINIAN: { key: "sc", value: "sc", name_en: "Sardinian", name: "sardu" },
  SERBIAN: { key: "sr", value: "sr", name_en: "Serbian", name: "Српски" },
  SHONA: { key: "sn", value: "sn", name_en: "Shona", name: "chiShona" },
  SICHUAN_YI: { key: "ii", value: "ii", name_en: "Sichuan Yi", name: "ꆈꌠ꒿ Nuosu" },
  SINDHI: { key: "sd", value: "sd", name_en: "Sindhi", name: "सिंधी" },
  SINHALA: { key: "si", value: "si", name_en: "Sinhala", name: "සිංහල" },
  SLOVAK: { key: "sk", value: "sk", name_en: "Slovak", name: "Slovenčina" },
  SLOVENIAN: { key: "sl", value: "sl", name_en: "Slovenian", name: "Slovenščina" },
  SOMALI: { key: "so", value: "so", name_en: "Somali", name: "Soomaaliga" },
  SOUTH_NDEBELE: { key: "nr", value: "nr", name_en: "South Ndebele", name: "isiNdebele" },
  SOUTHERN_SOTHO: { key: "st", value: "st", name_en: "Southern Sotho", name: "Sesotho" },
  SUNDANESE: { key: "su", value: "su", name_en: "Sundanese", name: "Basa Sunda" },
  SWAHILI: { key: "sw", value: "sw", name_en: "Swahili", name: "Kiswahili" },
  SWATI: { key: "ss", value: "ss", name_en: "Swati", name: "SiSwati" },
  TAGALOG: { key: "tl", value: "tl", name_en: "Tagalog", name: "Tagalog" },
  TAHITIAN: { key: "ty", value: "ty", name_en: "Tahitian", name: "Reo Tahiti" },
  TAJIK: { key: "tg", value: "tg", name_en: "Tajik", name: "тоҷикӣ" },
  TAMIL: { key: "ta", value: "ta", name_en: "Tamil", name: "தமிழ்" },
  TATAR: { key: "tt", value: "tt", name_en: "Tatar", name: "татар теле" },
  TELUGU: { key: "te", value: "te", name_en: "Telugu", name: "తెలుగు" },
  TIBETAN: { key: "bo", value: "bo", name_en: "Tibetan", name: "བོད་ཡིག" },
  TIGRINYA: { key: "ti", value: "ti", name_en: "Tigrinya", name: "ትግርኛ" },
  TONGA: { key: "to", value: "to", name_en: "Tonga", name: "faka Tonga" },
  TSONGA: { key: "ts", value: "ts", name_en: "Tsonga", name: "Xitsonga" },
  TSWANA: { key: "tn", value: "tn", name_en: "Tswana", name: "Setswana" },
  TURKMEN: { key: "tk", value: "tk", name_en: "Turkmen", name: "Türkmen" },
  TWI: { key: "tw", value: "tw", name_en: "Twi", name: "Twi" },
  UIGHUR: { key: "ug", value: "ug", name_en: "Uighur", name: "Uyghur" },
  URDU: { key: "ur", value: "ur", name_en: "Urdu", name: "اردو" },
  UZBEK: { key: "uz", value: "uz", name_en: "Uzbek", name: "Oʻzbek" },
  VENDA: { key: "ve", value: "ve", name_en: "Venda", name: "Tshivenḓa" },
  VOLAPUK: { key: "vo", value: "vo", name_en: "Volapük", name: "Volapük" },
  WALLOON: { key: "wa", value: "wa", name_en: "Walloon", name: "Walon" },
  WELSH: { key: "cy", value: "cy", name_en: "Welsh", name: "Cymraeg" },
  WESTERN_FRISIAN: { key: "fy", value: "fy", name_en: "Western Frisian", name: "Frysk" },
  WOLOF: { key: "wo", value: "wo", name_en: "Wolof", name: "Wollof" },
  XHOSA: { key: "xh", value: "xh", name_en: "Xhosa", name: "isiXhosa" },
  YIDDISH: { key: "yi", value: "yi", name_en: "Yiddish", name: "ייִדיש" },
  YORUBA: { key: "yo", value: "yo", name_en: "Yoruba", name: "Yorùbá" },
  ZHUANG: { key: "za", value: "za", name_en: "Zhuang", name: "Saɯ cueŋƅ" },
  ZULU: { key: "zu", value: "zu", name_en: "Zulu", name: "isiZulu" },
};

const ACTIVE_LANGS = [
  LANG.SPANISH_MX,
  LANG.SPANISH_ES,
  LANG.ENGLISH,
  LANG.PORTUGUESE_BR,
  LANG.PORTUGUESE_PT,
  LANG.ARABIC,
  //LANG.FRENCH,
  LANG.RUSSIAN,
  //LANG.CATALAN,
  //LANG.ITALIAN,
  // LANG.CHINESE_SIMP,
  //LANG.CHINESE_TRAD,
  //LANG.UKRAINIAN,
  //LANG.GERMAN,
  //LANG.KOREAN,
  LANG.JAPANESE,
  //LANG.POLISH,
  //LANG.TURKISH,
  //LANG.DUTCH,
  //LANG.SWEDISH,
  //LANG.AFRIKAANS
];

module.exports = {
  LANG,
  ACTIVE_LANGS,
};
